"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _useServerEffect = _interopRequireDefault(require("../../hooks/useServerEffect"));
var _useIsomorphicLayoutEffect = _interopRequireDefault(require("../../hooks/useIsomorphicLayoutEffect"));
var _Button = _interopRequireDefault(require("../Button"));
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Input = _interopRequireWildcard(require("../Input"));
var Styled = _interopRequireWildcard(require("./style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var CLASSNAME_PREFIX = 'input-group';
var _getChildType = function _getChildType(child) {
  var _a, _b, _c, _d;
  var type = '';
  if (child.type === _Input.default || ((_a = child.type) === null || _a === void 0 ? void 0 : _a.target) === _Input.default) {
    type = 'input';
  } else if (child.type === _Icon.default || ((_b = child.type) === null || _b === void 0 ? void 0 : _b.target) === _Icon.default) {
    type = 'icon';
  } else if (child.type === _Button.default || ((_c = child.type) === null || _c === void 0 ? void 0 : _c.target) === _Button.default || child.type === _IconButton.default || ((_d = child.type) === null || _d === void 0 ? void 0 : _d.target) === _IconButton.default) {
    type = 'element';
  } else {
    type = 'unknown';
  }
  return type;
};
//TODO: Support text elements to be rendered inside input like the icons
var InputGroup = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _a = props.size,
    size = _a === void 0 ? _Input.InputSizes.Normal : _a,
    _b = props.variant,
    variant = _b === void 0 ? _Input.InputVariants.Primary : _b,
    _c = props.variantType,
    variantType = _c === void 0 ? _Input.InputVariantTypes.Default : _c,
    _d = props.state,
    state = _d === void 0 ? _Input.InputStates.Default : _d,
    children = props.children,
    disabled = props.disabled,
    filteredProps = __rest(props, ["size", "variant", "variantType", "state", "children", "disabled"]);
  var _e = (0, _react.useState)({
      left: '',
      right: ''
    }),
    elements = _e[0],
    setElements = _e[1];
  var elementsEffect = (0, _react.useCallback)(function () {
    var elements = {
      left: '',
      right: ''
    };
    _react.Children.forEach(children, function (child, idx) {
      var childElement = child;
      if (idx === 0) {
        elements.left = childElement && childElement.type !== _Input.default ? _getChildType(childElement) : '';
      } else if (idx === _react.Children.count(children) - 1) {
        elements.right = childElement && childElement.type !== _Input.default ? _getChildType(childElement) : '';
      }
      setElements(function (current) {
        return __assign(__assign({}, current), elements);
      });
    });
  }, [children]);
  (0, _useServerEffect.default)(function () {
    elementsEffect();
  }, []);
  (0, _useIsomorphicLayoutEffect.default)(function () {
    elementsEffect();
  }, [elementsEffect]);
  var getChildPosition = (0, _react.useCallback)(function (index) {
    var position = '';
    if (index === 0) {
      position = 'left';
    } else if (index === _react.Children.count(children) - 1) {
      position = 'right';
    } else {
      position = 'center';
    }
    return position;
  }, [children]);
  var getChildClassName = (0, _react.useCallback)(function (child, index) {
    var type = _getChildType(child);
    var position = getChildPosition(index);
    return "".concat(CLASSNAME_PREFIX, "__").concat(type, " ").concat(CLASSNAME_PREFIX, "--").concat(position);
  }, [getChildPosition]);
  return (0, _jsxRuntime.jsx)(Styled.Wrapper, __assign({
    ref: ref,
    "$size": size,
    "$variant": variant,
    "$variantType": variantType,
    "$state": state,
    "$elements": elements,
    "$disabled": disabled
  }, filteredProps, {
    children: _react.Children.map(children, function (child, index) {
      var childElement = child;
      if (childElement) {
        var childClassName = [childElement.props.className || '', getChildClassName(childElement, index)].join(' ');
        var childProps = __assign(__assign({
          size: size,
          variant: variant,
          variantType: variantType,
          state: state,
          disabled: disabled
        }, childElement.props), {
          className: childClassName
        });
        return /*#__PURE__*/(0, _react.cloneElement)(childElement, childProps);
      } else {
        return null;
      }
    })
  }));
});
InputGroup.displayName = 'InputGroup';
var _default = InputGroup;
exports.default = _default;